<template>
    <div @mouseenter="setHoverTrue" @mouseleave="setHoverFalse" class="transition-all duration-300 ease-in-out w-full grid grid-cols-12" :class="[{'opacity-50' : isDragging && !isDropTargetOption }, {'max-h-10' : !hovering, 'max-h-96': hovering}]">
        <div class="col-span-1 px-3 py-2 bg-emerald-200 border-b border-r border-l border-gray-300 flex items-center justify-center">
            <ArrowsUpDownSVG class="hover:cursor-pointer"/>
        </div>
        <div :class="[{'truncate': truncating}]" class="col-span-1 px-3 py-2 bg-emerald-200 border-b border-r border-l border-gray-300">{{ displayName }}</div>
        <div :class="[{'truncate': truncating}]" class="col-span-2 px-3 py-2 bg-emerald-200 border-b border-r border-l border-gray-300">{{ label }}</div>
        <div :class="[{'bg-emerald-200' : status === 'Done', 'bg-yellow-100' : status === 'Open'}, {'truncate': truncating}]" class="col-span-1 flex justify-start px-3 py-2  border-b border-r border-gray-300">{{ dueDate }}</div>
        <div :class="[{'truncate': truncating}]" class="col-span-1 flex justify-start px-3 py-2 bg-emerald-200 border-b border-r border-gray-300">{{ resolvedDate }}</div>
        <div :class="[{'truncate': truncating}]" class="col-span-1 px-3 py-2 bg-emerald-200 border-b border-r border-gray-300">{{ task.user ? `${task.user.first_name} ${task.user.last_name}` : '--' }} ({{ task.created_by ? `${task.created_by.first_name.substring(0, 1)}${task.created_by.last_name.substring(0, 1)}` : '--' }})</div>
        <div :class="[{'bg-emerald-200' : status === 'Done', 'bg-yellow-100' : status === 'Open'}, {'truncate': truncating}]"  class="col-span-1 px-3 py-2  border-b border-r text-center border-gray-300">{{ status }}</div>
        <div :class="[{'truncate': truncating}]" class="col-span-2 px-3 overflow-auto max-h-96 py-2 bg-emerald-200 border-b border-r border-gray-300">{{ task.task_notes ? task.task_notes : '--' }}</div>
        <div :class="[{'truncate': truncating}]" class="col-span-2 px-3 overflow-auto max-h-96 py-2 bg-emerald-200 border-b border-r border-gray-300">{{ task.correspondence ? task.correspondence : '--' }}</div>

    </div>
    </template>
    
    <script setup>
    import { ref, defineProps, computed, watch } from 'vue';
    import { formatDate } from '@/composables/formatDate';
    // import InfoModal from '../InfoModal.vue';
    import ArrowsUpDownSVG from '../svg-components/ArrowsUpDownSVG.vue';
    
    const props = defineProps(['task', 'isDragging', 'draggingDueDate', 'draggingResolvedDate'])
    
    const visibleDetailsModal = ref(false)
    
    function showDetailsModal() {
        visibleDetailsModal.value = true
    }
    
    const hovering = ref(false)
    const shouldExpand = ref(false)
    
    function setHoverTrue(){
        shouldExpand.value = true
        setTimeout(() => {
            if(shouldExpand.value){
                hovering.value = true 
            }
        }, 750)
    }
    
    watch(hovering, () => {
        if(hovering.value) {
            truncating.value = false
        } else {
            setTimeout(() => {
                truncating.value = true
            }, 300)
    
        }
    })
    
    function setHoverFalse(){
        shouldExpand.value = false
        hovering.value = false
    }
    
    const truncating = ref(true)
    
    const isDropTargetOption = computed(() => {
        if(!props.task.resolved_date){
            return (props.isDragging && props.draggingDueDate == props.task.due_date) || (props.isDragging && !props.draggingDueDate && !props.task.due_date)
        } else {
            return (props.isDragging && props.draggingResolvedDate == props.task.resolved_date)
        }
    })
    
    const displayName = computed(() => {
        if(props.task){
            return props.task.resolved_date ? props.task.task_type.resolved_label : props.task.task_type.unresolved_label
        } else {
            return '--'
        }
    })

    const label = computed(() => {
        if(props.task){
            return props.task.task_label ? props.task.task_label : '--'
        } else {
            return '--'
        }
    })
    
    const dueDate = computed(() => {
        if(props.task){
            return props.task.due_date ? formatDate(props.task.due_date): '--'
        } else {
            return '--'
        }
    })
    
    const resolvedDate = computed(() => {
        if(props.task){
            return props.task.resolved_date ? formatDate(props.task.resolved_date): '--'
        } else {
            return '--'
        }
    })
    
    const status = computed(() => {
        return props.task.resolved_date ? 'Done' : 'Open'
    })
    
    </script>